import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';

import InputMask from 'react-input-mask';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';

import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import { Global } from '../services/Global';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';
import { SUBMISSION_TYPE, TYPE_FORM } from '../utils/constants';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class WorkingInformationPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: FormFields.working_information,
            next_active: false,
            datasend_current: null,

            rubrosEmpresa: [],
            catalogNroEmpleados: [],
            search_result: [],

            fechaDesde1: '',
            fechaHasta1: '',
            fechaDesde2: '',
            fechaHasta2: '',
            fechaDesde3: '',
            fechaHasta3: '',

            datasend: {
                1: {
                    id: '',
                    idSubmission: '',
                    idTipo: '',
                    idInstitucionEducativa: '',
                    idGradoEstudio: '',
                    profesion: '',
                    fechaDesde: '',
                    fechaHasta: '',
                    ciudad: '',
                    especialidad: '',
                    orden: '1',
                    estado: ''
                }
            },

            selectionRange: {
                startDate: null,
                endDate: null,
                key: 'selection'
            }
        }
    }

    componentDidMount() {
        let _root = this;
        Tools.showPreloader();
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {

            let formFields = ['laboralCentroTrabajo', 'laboralFechaInicio', 'laboralRubroEmpresa', 'laboralArea', 'laboralCargo', 'laboralDescripcionCargo', 'laboralDireccion', 'laboralTelefono', 'laboralEmail'];
            formFields.forEach(element => {
                //console.log(element, _root.props.pro[element]);
            });

            let _datasend = { ..._root.state.datasend };
            _datasend['1'].idSubmission = _root.props.pro.idSubmission;

            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                rubrosEmpresa: _root.props.glo.rubrosEmpresa,
                catalogNroEmpleados: [{ id: 1, nombre: "1-10" }, { id: 2, nombre: "11-50" }, { id: 3, nombre: "51-200" }, { id: 4, nombre: "200 a más" }],
                datasend: _datasend
            });

            let _stateProps = { ..._root.props.pro };
            //console.log('_stateProps', _stateProps, _root.props.glo.otherinfo);



            if (_root.props.pro.laboralNoLaborando === true) {
                document.getElementById('laboralNoLaborando').checked = true;

                for (let key in _root.state.fields) {
                    if (_root.state.fields[key].isRequired) {
                        if (document.getElementById(key)) {
                            _root.props.pro[key] = '';
                            document.getElementById(key).value = '';
                            document.getElementById(key).disabled = true;
                            document.getElementById(key).classList.add('disabled');
                        }
                    }
                }
                _root.setState({
                    next_active: true
                });
                _root.props.process(_root.props.pro);
            }
            else {
                //console.info('Search other information', _root.props.glo.otherinfo);
                _root.props.pro.laboralCentroTrabajo = (_stateProps.laboralCentroTrabajo != null) ? _stateProps.laboralCentroTrabajo : _root.props.glo.otherinfo?.empresa;
                _root.props.pro.laboralNroEmpleados = (_stateProps.laboralNroEmpleados != null) ? _stateProps.laboralNroEmpleados : _root.props.glo.otherinfo?.nroEmpleados;
                _root.props.pro.laboralCargo = (_stateProps.laboralCargo != null) ? _stateProps.laboralCargo : _root.props.glo.otherinfo?.cargo;
                if (_root.props.pro.idSubmissionType === SUBMISSION_TYPE.TYPE_PDE) {
                    _root.props.pro.laboralDescripcionCargo = (_stateProps.laboralDescripcion != null) ? _stateProps.laboralDescripcion : _root.props.glo.otherinfo?.cargo;
                    console.log('DSC', '' + _root.props.pro.laboralDescripcionCargo);
                    _root.props.pro.laboralDescripcion = '' + _root.props.pro.laboralDescripcionCargo;
                }
                _root.props.pro.laboralRubroEmpresa = (_stateProps.laboralRubroEmpresa !== '') ? _stateProps.laboralRubroEmpresa : _root.props.glo.otherinfo?.rubro;
                //laboralDescripcionCargo
                _root.props.process(_root.props.pro);

                // document.getElementById('laboralNoLaborando').checked = false;

                // _root.props.pro.laboralRubroEmpresa = "14";
                // document.getElementById('laboralRubroEmpresa').value = 14;
                // console.log(_root.props.pro.laboralRubroEmpresa);

                // let _selectEntity = { ..._root.props.pro };
                // _selectEntity.laboralRubroEmpresa = 14;


                _root.setState({
                    next_active: false
                });
            }


            if (_root.props.pro.idSubmissionType === SUBMISSION_TYPE.TYPE_PDE) {

                ApiService.getData(`${APIS.institucionEducativa}${_root.props.pro.institucionProcedencia}`).then(resie => {
                    if (resie.data.nombre !== undefined) {
                        _root.state.datasend['1'].idInstitucionEducativa = _root.props.pro.institucionProcedencia;
                        document.getElementById(`idInstitucionEducativa1`).value = resie.data.nombre
                        ApiService.getData(`${APIS.estudioAcademicoByIdSubmission}${_root.props.pro.idSubmission}`).then(res => {
                            if (res.data.length > 0) {
                                let item = res.data.shift();
                                console.log('item shift', item);
                                _root.state.datasend[item.idTipo].id = item.id;
                                _root.state.datasend[item.idTipo].idSubmission = item.idSubmission;
                                _root.state.datasend[item.idTipo].idTipo = item.idTipo;
                                _root.state.datasend[item.idTipo].idInstitucionEducativa = item.idInstitucionEducativa;
                                _root.state.datasend[item.idTipo].idGradoEstudio = item.idGradoEstudio;
                                _root.state.datasend[item.idTipo].profesion = item.profesion;
                                //_root.state.datasend[item.idTipo].fechaDesde = item.fechaDesde;
                                //_root.state.datasend[item.idTipo].fechaHasta = item.fechaHasta;

                                _root.state.datasend[item.idTipo].fechaDesde = Global.convertDateStartEnd(item.fechaDesde);
                                _root.state.datasend[item.idTipo].fechaHasta = Global.convertDateStartEnd(item.fechaHasta);

                                _root.state.datasend[item.idTipo].ciudad = item.ciudad;
                                _root.state.datasend[item.idTipo].especialidad = item.especialidad;
                                _root.state.datasend[item.idTipo].orden = item.orden;
                                _root.state.datasend[item.idTipo].estado = item.estado;
                                // ApiService.getData(`${APIS.institucionEducativa}${item.idInstitucionEducativa}`)
                                ApiService.getData(`${APIS.institucionEducativa}${_root.props.pro.institucionProcedencia}`)
                                    .then(resie => {
                                        if (resie.data.nombre !== undefined) {
                                            if (document.getElementById(`idInstitucionEducativa${item.idTipo}`)) { document.getElementById(`idInstitucionEducativa${item.idTipo}`).value = resie.data.nombre };
                                            if (document.getElementById(`idGradoEstudio${item.idTipo}`)) { document.getElementById(`idGradoEstudio${item.idTipo}`).value = item.idGradoEstudio };
                                        }
                                    })
                                    .catch(err => {
                                        console.log(err);
                                    });
                                document.getElementById(`profesion${item.idTipo}`).value = item.profesion;
                                _root.setState({
                                    datasend: _root.state.datasend,
                                    [`fechaDesde${item.idTipo}`]: Global.convertDateStartEnd(item.fechaDesde),
                                    [`fechaHasta${item.idTipo}`]: Global.convertDateStartEnd(item.fechaHasta),
                                    rubrosEmpresa: _root.props.glo.rubrosEmpresa
                                });

                            }
                        }).catch(err => {
                            Tools.hidePreloader();
                            console.log(err);
                        });
                    }
                }).catch(err => { });
            }
        }
        Tools.hidePreloader();
    }

    onChangeDateRange = (ranges) => {
        // console.log(ranges);
    }

    onChange = e => {
        // e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_root.props.pro[_target.name] !== undefined) {

            switch (_target.name) {
                case 'laboralNoLaborando':
                    _root.props.pro[_target.name] = _target.checked;

                    for (let key in _root.state.fields) {
                        if (_root.state.fields[key].isRequired) {

                            Global.removeMessageError(key);
                            if (_target.checked) {
                                if (key === 'laboralFechaInicio') {
                                    _root.props.pro[key] = -1;
                                }
                                else {
                                    _root.props.pro[key] = '';
                                }

                                if (document.getElementById(key)) {
                                    if (key === 'laboralRubroEmpresa') {
                                        document.getElementById(key).value = -1;
                                    } else {
                                        document.getElementById(key).value = '';
                                    }
                                    //document.getElementById(key).value = '';
                                    document.getElementById(key).disabled = true;
                                    document.getElementById(key).classList.add('disabled');
                                }

                                _root.setState({
                                    next_active: true
                                });
                            }
                            else {

                                if (document.getElementById(key)) {
                                    document.getElementById(key).disabled = false;
                                    document.getElementById(key).classList.remove('disabled');
                                    // Global.removeMessageError(key);
                                }
                                _root.setState({
                                    next_active: false
                                });

                            }
                        }
                    }
                    break;
                case 'laboralDescripcionCargo':
                    _root.props.pro.laboralDescripcion = _target.value;
                    _root.props.pro.laboralDescripcionCargo = _target.value;
                    break;
                default:
                    _root.props.pro[_target.name] = _target.value;
                    break;
            }

            _root.setState({
                next_active: true
            });
        }
        else {
            if (_target.getAttribute('data-type')) {
                if (_target.getAttribute('data-type') === 'search') {
                    _root.setState({
                        search_result: []
                    }, () => {
                        if (_target.value.length > 1) {
                            ApiService.getData(`${APIS.institucionesEducativasNombre}/${_target.value}`)
                                .then(res => {
                                    if (res.data.length > 0) {
                                        _root.setState({
                                            search_result: res.data
                                        }, () => {
                                            if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                                _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'block';
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                        else {
                            _root.setState({
                                search_result: []
                            }, () => {
                                if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                    _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'none';
                                }
                            });
                        }
                    });
                }
            }
            else {
                _root.state.datasend[_target.getAttribute('data-level')]['idSubmission'] = _root.props.pro.idSubmission;
                _root.state.datasend[_target.getAttribute('data-level')][_target.name] = _target.value;
                _root.state.datasend[_target.getAttribute('data-level')].idTipo = _target.getAttribute('data-level');
                _root.setState({
                    datasend: _root.state.datasend
                }, () => {
                });
            }
        }
    }

    onBlur = e => {
    }

    onFocus = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_target.name == 'fechaDesde' || _target.name == 'fechaHasta') {
            _root.setState({
                datasend_current: _target.getAttribute('data-level')
            }, () => {

            });
        }
    }

    onClickResultItem = (e) => {
        e.preventDefault();
        let _root = this;
        let _target = e.currentTarget;

        if (_target.getAttribute('data-id')) {
            _root.state.datasend[_target.getAttribute('data-level')]['idInstitucionEducativa'] = parseInt(_target.getAttribute('data-id'));
            document.getElementById(`${_target.getAttribute('data-name')}${_target.getAttribute('data-level')}`).value = _target.getAttribute('data-value');
            for (let item of document.querySelectorAll('.search-result')) {
                item.style.display = 'none';
            }
        }
    }



    onChangeDate = (e) => {
        let _root = this;
        let _target = e.target;

        _root.state.datasend[_target.getAttribute('data-level')]['idSubmission'] = _root.props.pro.idSubmission;
        _root.state.datasend[_target.getAttribute('data-level')][_target.name] = _target.value;
        _root.state.datasend[_target.getAttribute('data-level')].idTipo = _target.getAttribute('data-level');
        _root.setState({
            datasend: _root.state.datasend
        });


        if (_root.state.datasend_current !== null) {

            if (_target.name !== undefined) {
                if (_target.name == 'fechaDesde' || _target.name == 'fechaHasta') {
                    _root.setState({
                        [`${_target.name}${_root.state.datasend_current}`]: _target.value
                    }, () => {
                        if (Global.validateDateStartEnd(_target.value)) {
                            //_root.state.datasend[_root.state.datasend_current][_target.name] = (`20-${_target.value}`).split('-').reverse().join('-');
                            _root.state.datasend[_root.state.datasend_current][_target.name] = _target.value;//(`${_target.value}`).split('-').reverse().join('-');
                            // if(document.getElementById(`${_target.name}${_root.state.datasend_current}`)) {
                            //     document.getElementById(`${_target.name}${_root.state.datasend_current}`).value = _target.value;
                            // }
                            _root.setState({
                                datasend: _root.state.datasend
                            }, () => {
                                if (_root.state.datasend[_root.state.datasend_current]['fechaDesde'] != '' && _root.state.datasend[_root.state.datasend_current]['fechaHasta'] != '') {
                                    if (!Global.checkGreaterDates(_root.state.datasend[_root.state.datasend_current]['fechaDesde'], _root.state.datasend[_root.state.datasend_current]['fechaHasta'])) {
                                        Tools.showToaster('error', '', 'La Fecha desde no puede ser mayor o igual que Hasta...');
                                    }
                                }
                            });
                        }
                        else {
                            // Tools.showToaster('error', '', 'El mes debe ser entre 1 y 12', 500);   
                        }
                    });
                }
            }
        }
    }

    onKeyPressInputValidate = param => (event) => {
        let _root = this;
        let _target = event.target;

        switch (_target.name) {
            case '':
                break;
            default:
                Global.onKeyPressInputValidate(event, param);
                break;
        }
    }




    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        let _selectEntity = { ..._root.props.pro };


        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/informacion-laboral'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);

        //validate form
        console.log('_root.props.pro', _root.props.pro);

        let isValidateForm = [];

        //Información Académica
        if (_root.props.pro.idSubmissionType === SUBMISSION_TYPE.TYPE_PDE) {
            let _selectEntityValidate = { ..._root };
            console.log('_selectEntityValidate', _root.state);
            //_selectEntityValidate.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO].fechaDesde = Global.convertDateStartEnd(_selectEntity.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO].fechaDesde);
            //_selectEntityValidate.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO].fechaHasta = Global.convertDateStartEnd(_selectEntity.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO].fechaHasta);
            isValidateForm.push(...Global.validateFormAcademicInformation(TYPE_FORM.INF_ACADEMIC_PREGRADO, _selectEntityValidate));
        }

        //Información Laboral Actual
        if (!this.props.pro.laboralNoLaborando) {
            isValidateForm.push(...Global.formValidationList(FormFields.working_information, _selectEntity));
            console.log('isValidateForm', isValidateForm.length, isValidateForm);

            //Custom validation
            console.log('_selectEntity.laboralFechaInicio', _selectEntity.laboralFechaInicio);
            if (_selectEntity.laboralFechaInicio === null || _selectEntity.laboralFechaInicio === '') {
                Global.addMessageError('laboralFechaInicio', 'Fecha de inicio es obligatorio');
                isValidateForm.push('laboralFechaInicio');
            } else {
                Global.removeMessageError('laboralFechaInicio')
            }
        } else {
            _root.props.pro.laboralFechaInicio = '2001-01-01';
            _root.props.process(_root.props.pro);
        }
        if (isValidateForm.length > 0) { return false }

        Tools.showPreloader();
        if (_root.props.pro.idSubmissionType === SUBMISSION_TYPE.TYPE_PDE) {
            console.log('_root.state.datasend 1', _root.state.datasend['1']);
            _root.state.datasend['1'].idTipo = parseInt(_root.state.datasend['1'].idTipo);
            _root.state.datasend['1'].idGradoEstudio = parseInt(_root.state.datasend['1'].idGradoEstudio);



            if (_root.state.datasend['1'].idSubmission !== '') {

                let sendInfAcademic = { ..._root.state.datasend['1'] };
                sendInfAcademic.fechaDesde = (`20-${_root.state.datasend['1'].fechaDesde}`).split('-').reverse().join('-');
                sendInfAcademic.fechaHasta = (`20-${_root.state.datasend['1'].fechaHasta}`).split('-').reverse().join('-');
                Tools.showPreloader();
                ApiService.postData(`${APIS.estudioAcademico}`, sendInfAcademic)
                    .then(res => {
                        Tools.hidePreloader();
                    })
                    .catch(err => {
                        Tools.hidePreloader();
                        console.log(err);
                    });
            }
        }
        ApiService.postData(`${APIS.submission} `, _root.props.pro)
            .then(res => {
                Tools.hidePreloader();

                _root.props.process(_root.props.pro);
                _root.props.general(_root.props.glo);
                _root.props.navigate((_root.props.pro.idSubmissionType === SUBMISSION_TYPE.TYPE_MAES) ? '/datos-laborales' : '/forma-pago');
            })
            .catch(err => {
                Tools.hidePreloader();
            });
    }

    render() {

        const {
            next_active,
            program_selected,
            rubrosEmpresa,
            catalogNroEmpleados,
            search_result,
            fechaDesde1,
            fechaHasta1,
            fechaDesde2,
            fechaHasta2,
            fechaDesde3,
            fechaHasta3
        } = this.state;

        const {
            pro,
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'2'} form={program_selected.form} /> : <></>}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="40" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6">
                                            <TopComponent direction="back" label="Paso Previo " path={(pro.idSubmissionType === SUBMISSION_TYPE.TYPE_MAES) ? "/informacion-academica" : "/datos-generales"} />
                                        </div>
                                        <div className="col-sm-12 col-md-6" />
                                    </div>

                                    {(pro.idSubmissionType === SUBMISSION_TYPE.TYPE_PDE) &&
                                        <>
                                            <div className="row pt-2 pb-2">
                                                <div className="col-sm-12 col-md-6">
                                                    <h5><strong>Información Académica</strong></h5>
                                                </div>
                                                <div className="col-sm-12 col-md-6 text-right">
                                                    <small><strong>Cuéntanos más sobres tus estudios de Bachiller.</strong></small>
                                                </div>
                                            </div>
                                            <div className="row pt-2 pb-2">
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="grado" className="pb-2">Nivel Máximo Obtenido <span className="text-danger">*</span></label>
                                                        <select data-level="1" defaultValue={''} className="form-control" id="idGradoEstudio1" name="idGradoEstudio" onChange={this.onChange}>
                                                            <option value={''}>Selecciona una opción</option>
                                                            {
                                                                this.props.glo.gradosAcademicos.map((item, i) => (
                                                                    <option key={(i + 1) + 'gaca'} value={item.id}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2 search-form">
                                                        <label htmlFor="institucionProcedencia" className="pb-2">Institución Educativa <span className="text-danger">*</span></label>
                                                        <input data-level="1" type="text" className="form-control" id="idInstitucionEducativa1" data-type="search" placeholder="Escribe el nombre de la institución" aria-describedby="nameHelp" onChange={this.onChange} autoComplete="off" />
                                                        <div className="search-result">
                                                            {
                                                                search_result.map((item, i) => (
                                                                    <div key={(i + 1) + 'inedu'} data-id={item.id} data-level="1" data-name="idInstitucionEducativa" data-value={item.nombre} className="search-result-item" onClick={this.onClickResultItem}>
                                                                        <small>{item.nombre}</small>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="profesion" className="pb-2">Profesión <span className="text-danger">*</span></label>
                                                        <input data-level="1" size={150} type="text" className="form-control" id="profesion1" name="profesion" aria-describedby="nameHelp" onChange={this.onChange} />
                                                        <div className="invalid-feedback"></div>
                                                    </div>

                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2 gri">
                                                        <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta<span className="text-danger">*</span></label>
                                                        <div className="input-tg-inline">
                                                            <InputMask maskChar="" data-level="1" id="fechaDesde1" className="form-control" mask="99-9999" name="fechaDesde" value={fechaDesde1} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                            <InputMask maskChar="" data-level="1" id="fechaHasta1" className="form-control" mask="99-9999" name="fechaHasta" value={fechaHasta1} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                            <div className="invalid-feedback"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <h5><strong>Información Laboral Actual</strong></h5>
                                        </div>
                                        <div className="col-sm-12 col-md-8">
                                            <div className="form-check pb-2">
                                                <input className="form-check-input" type="checkbox" id="laboralNoLaborando" name="laboralNoLaborando" onChange={this.onChange} />
                                                <label className="form-check-label" htmlFor="laboralNoLaborando">No me encuentro laborando</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralCentroTrabajo" className="pb-2">Centro de Trabajo Actual <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="laboralCentroTrabajo" name="laboralCentroTrabajo"
                                                    onChange={this.onChange}
                                                    onBlur={this.onBlur}
                                                    disabled={this.props.pro.laboralNoLaborando}
                                                    value={this.props.pro.laboralCentroTrabajo} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralFechaInicio" className="pb-2">Fecha de Inicio <span className="text-danger">*</span></label>
                                                <input type="date" className="form-control" id="laboralFechaInicio" name="laboralFechaInicio" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralFechaInicio} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralRubroEmpresa" className="pb-2">Actividad o Rubro de la Empresa <span className="text-danger">*</span></label>
                                                <select className="form-control" id="laboralRubroEmpresa" name="laboralRubroEmpresa"
                                                    onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralRubroEmpresa}
                                                    disabled={this.props.pro.laboralNoLaborando}
                                                >
                                                    <option value={""}>Selecciona una opción</option>
                                                    {
                                                        rubrosEmpresa.map((item, i) => (
                                                            <option key={(i + 1) + 're'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralArea" className="pb-2">Area <span className="text-danger">*</span></label>
                                                <input type="text" maxLength={60} className="form-control" id="laboralArea" name="laboralArea" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralArea} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralArea" className="pb-2">Nro Empleados <span className="text-danger">*</span></label>
                                                <select className="form-control" id="laboralNroEmpleados" name="laboralNroEmpleados"
                                                    onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralNroEmpleados}>
                                                    <option value={""}>Selecciona una opción</option>
                                                    {
                                                        catalogNroEmpleados.map((item, i) => (
                                                            <option key={(i + 1) + 're'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralCargo" className="pb-2">Cargo <span className="text-danger">*</span></label>
                                                <input type="text" maxLength={60} className="form-control" id="laboralCargo" name="laboralCargo" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralCargo} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralDescripcionCargo" className="pb-2">Descripción del Cargo <span className="text-danger">*</span></label>
                                                <input type="text" maxLength={120} className="form-control" id="laboralDescripcionCargo" name="laboralDescripcionCargo" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralDescripcionCargo} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralDireccion" className="pb-2">Dirección <span className="text-danger">*</span></label>
                                                <input type="text" maxLength={120} className="form-control" id="laboralDireccion" name="laboralDireccion" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralDireccion} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralTelefono" className="pb-2">Teléfono Fijo o Celular <span className="text-danger">*</span></label>
                                                <input type="text" maxLength="9" className="form-control" id="laboralTelefono" name="laboralTelefono" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralTelefono} onKeyPress={this.onKeyPressInputValidate('only_number_positive')} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="laboralEmail" className="pb-2">E-mail <span className="text-danger">*</span></label>
                                                <input type="email" className="form-control" id="laboralEmail" name="laboralEmail" onChange={this.onChange} onBlur={this.onBlur} value={this.props.pro.laboralEmail} autoComplete="off" aria-describedby="nameHelp" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <small className="text-danger">*Obligatorio</small>
                                        </div>
                                        <div className="col-sm-12 col-md-4"></div>
                                        <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                            <button className={'btn btn-primary btn-style-4'} onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkingInformationPage);